/**
* 下载文件
* @param url 文件地址，必传
* @param name 文件名称，不传时使用原文件名
*/
export default function downloadFile(xhrUrl, name) {
  if (!xhrUrl) return;
  let url = xhrUrl;
 const xhr = new XMLHttpRequest();
 xhr.open('get', url, true);
 const tokenKey = process.env.VUE_APP_TOKENKEY;
 const token = getToken();
 xhr.setRequestHeader(
  tokenKey, token,
 );
 xhr.responseType = "blob";
 xhr.onload = function() {
   if (xhr.status === 200) {
     // 设置文件名称
     let filename = '';
     if (name) {
       if (name.includes('.')) {
         filename = name;
       } else {
         const index = url.lastIndexOf('.');
         const len = str.length;
         const type = str.substring(index, len); // 后缀名：.xxx
         filename = `${name}${type}`;
       }
     } else {
       // 如果没有传入name，就获取原文件名称
       const disposition = xhr.getResponseHeader('Content-Disposition');
       if (disposition) {
         // 从responseHeader中取，需要后端接口设置‘Content-Disposition’
         filename = disposition.split(';')[1].split('filename=')[1];
         const fileNameUnicode = disposition.split('filename*=')[1];
         if (fileNameUnicode) {
           //当存在 filename* 时，取filename* 并进行解码（为了解决中文乱码问题）
           filename = decodeURIComponent(fileNameUnicode.split("''")[1]);
         }
       } else {
         // 还是取不到文件名，就尝试从url里面去截取吧
         const index = url.lastIndexOf('/');
         const len = url.length;
         filename = url.substring(index + 1, len);
       }
     }
     // a标签download属性下载
     const blob = new Blob([xhr.response]);
     if (window.navigator.msSaveOrOpenBlob) {
       navigator.msSaveBlob(blob, filename);
     } else {
       const a = document.createElement('a');
       a.style.display = 'none';
       a.href = window.URL.createObjectURL(blob);
       a.download = filename;
       document.body.appendChild(a);
       a.click();
       window.URL.revokeObjectURL(a.href);
       document.body.removeChild(a);
     }
   }
 }
 xhr.send();
}